// extracted by mini-css-extract-plugin
export default {"container":"EntityTable_container__59ReD","dismissedDescription":"EntityTable_dismissedDescription__G3YKP","pagination":"EntityTable_pagination__X4izs"};